import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from './../../../environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { BussinessDocumentsResolutionModel } from './../../models/management/bussiness-documents-resolution.models';

@Injectable({
  providedIn: 'root'
})
export class BussinessDocumentsResolutionService {

  constructor(private _httpClient: HttpClient) { }

  createBussinessDocumentsResolution(bussinessDocumentsResolutionContract: BussinessDocumentsResolutionModel): Observable<BussinessDocumentsResolutionModel> {
    return this._httpClient.post<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.CreateBussinessDocumentsResolution}`,
      bussinessDocumentsResolutionContract);
  }

  deleteBussinessDocumentsResolution(bussinessDocumentsResolutionId: number): Observable<BussinessDocumentsResolutionModel> {
    return this._httpClient.delete<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.DeleteBussinessDocumentsResolution}/${bussinessDocumentsResolutionId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllBussinessDocumentsResolutionsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetAllBussinessDocumentsResolutionsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetColumnsForGeneralConsultationAsync}`);
  }

  getBussinessDocumentsResolutionById(bussinessDocumentsResolutionId: number): Observable<BussinessDocumentsResolutionModel> {
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetBussinessDocumentsResolutionById}/${bussinessDocumentsResolutionId}`);
  }

  getBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId: number, consecutive: number): Observable<BussinessDocumentsResolutionModel> {
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetBussinessDocumentsResolutionByKeys}/${bussinessDocumentsTypeId}/${consecutive}`);
  }

  getFirstBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId: number): Observable<BussinessDocumentsResolutionModel> {
    const params = new HttpParams().set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetFirstBussinessDocumentsResolutionByKeysAsync}`,
      { params: params }
    );
  }

  getLastBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId: number): Observable<BussinessDocumentsResolutionModel> {
    const params = new HttpParams().set('bussinessDocumentsTypeId', bussinessDocumentsTypeId);
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetLastBussinessDocumentsResolutionByKeysAsync}`,
      { params: params }
    );
  }

  getNextBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId: number, consecutive: number): Observable<BussinessDocumentsResolutionModel> {
    const params = new HttpParams().set('bussinessDocumentsTypeId', bussinessDocumentsTypeId).set('consecutive', consecutive);
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetNextBussinessDocumentsResolutionByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusBussinessDocumentsResolutionByKeys(bussinessDocumentsTypeId: number, consecutive: number): Observable<BussinessDocumentsResolutionModel> {
    const params = new HttpParams().set('bussinessDocumentsTypeId', bussinessDocumentsTypeId).set('consecutive', consecutive);
    return this._httpClient.get<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetPreviusBussinessDocumentsResolutionByKeysAsync}`,
      { params: params }
    );
  }

  getResolutionExpirationStatus(dateInvoice: Date, enterpriseId: number): Observable<number> {
    const params = new HttpParams().set('dateInvoice', dateInvoice.toISOString()).set('enterpriseId', enterpriseId);
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.GetResolutionExpirationStatusAsync}`,
      { params: params });
  }

  updateBussinessDocumentsResolution(bussinessDocumentsResolutionContract: BussinessDocumentsResolutionModel): Observable<BussinessDocumentsResolutionModel> {
    return this._httpClient.put<BussinessDocumentsResolutionModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.bussinessDocumentsResolution.UpdateBussinessDocumentsResolution}`,
      bussinessDocumentsResolutionContract);
  }
}
